import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { ADD_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const AddRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={ADD_ROUNDED_GLYPH} />;
